/*=========================================================================================
  File Name: moduleMap.js
  Description: Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import state from "./moduleRoutingTypeState.js";
import mutations from "./moduleRoutingTypeMutations.js";
import actions from "./moduleRoutingTypeActions.js";

export default {
	namespaced: true,
	state,
	mutations,
	actions,
};
